/**
 * RedirectHelper.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 페이지의 앞페이지, 뒷페이지를 검증하는 클래스입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

export type RedirectOrigin = 'same-origin' | 'diff';

class RedirectObject {
  path: string;
  origin: RedirectOrigin;

  constructor(origin: RedirectOrigin, path: string) {
    this.path = path;
    this.origin = origin;
  }
}

/* 특정 페이지 진입 이전, 다른 페이지를 거쳐와야 할 때 사용하는 Helper */
export default class RedirectHelper {
  private static LocalRedirectObject: RedirectObject | null = null;
  private static PageRedirectSessionStorageKey: string = '__dl_page_redirect__';

  /**
   * @param origin 거쳐와야 할 페이지와 특정 페이지가 같은 Route인지 판단하는 값
   */
  constructor() {}

  private setPageRedirectObject = (path: string, origin: RedirectOrigin) => {
    try {
      if (!RedirectHelper.LocalRedirectObject) {
        const redirectObject = new RedirectObject(origin, path);

        RedirectHelper.LocalRedirectObject = redirectObject;

        const stringifyObject = JSON.stringify(redirectObject);

        sessionStorage.setItem(RedirectHelper.PageRedirectSessionStorageKey, stringifyObject);
      }
    } catch (e) {
      return null;
    }
  };

  private getPageRedirectObject = (): RedirectObject | null => {
    try {
      const stringifyObject = sessionStorage.getItem(RedirectHelper.PageRedirectSessionStorageKey);
      const parseObject = stringifyObject && JSON.parse(stringifyObject);
      const isValidObject = parseObject && parseObject.hasOwnProperty('path') && parseObject.hasOwnProperty('origin');

      if (isValidObject || RedirectHelper.LocalRedirectObject) {
        return isValidObject ? parseObject : RedirectHelper.LocalRedirectObject;
      } else {
        throw new Error();
      }
    } catch (e) {
      return null;
    }
  };

  clearRedirectData = () => {
    RedirectHelper.LocalRedirectObject = null;
    sessionStorage.removeItem(RedirectHelper.PageRedirectSessionStorageKey);
  };

  setPageRedirectData = (accessPage: string, origin: RedirectOrigin) => {
    this.setPageRedirectObject(accessPage, origin);
  };

  getIsRedirectData = (): RedirectObject | null => {
    return this.getPageRedirectObject();
  };
}
